/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisablePaymentFormOutput
 */
export interface DisablePaymentFormOutput {
    /**
     * 
     * @type {string}
     * @memberof DisablePaymentFormOutput
     */
    message?: string;
    /**
     * 
     * @type {Error}
     * @memberof DisablePaymentFormOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the DisablePaymentFormOutput interface.
 */
export function instanceOfDisablePaymentFormOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DisablePaymentFormOutputFromJSON(json: any): DisablePaymentFormOutput {
    return DisablePaymentFormOutputFromJSONTyped(json, false);
}

export function DisablePaymentFormOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisablePaymentFormOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function DisablePaymentFormOutputToJSON(value?: DisablePaymentFormOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'error': value.error,
    };
}

